<template>
  <div>
    <div class="field field_search">
      <a class="btn" v-if="!disabled" @click.stop="$emit('select', value)" v-translate>
        Vybrat vysílání
      </a>
    </div>
    <table class="vypis vypis_detail" v-if="value.length > 0">
      <thead>
        <tr>
          <th class="no_padding drag_drop"></th>
          <th><span class="name" v-translate>ID</span></th>
          <th><span class="name" v-translate>Název</span></th>
          <th><span class="name" v-translate>Kanál</span></th>
          <th><span class="name" v-translate>Datum a čas</span></th>
          <th v-if="!disabled"></th>
        </tr>
      </thead>
      <tbody :class="['sortable_' + name, {sortable: !disabled, 'ui-sortable': !disabled}]">
        <tr :class="['sorted_' + name, {'ui-sortable-handle': !disabled}]" v-for="id in value" :key="'broadcast_' + name + '_' + id" :rowvalue="id">
          <td class="no_padding drag_drop"><span/></td>
          <td class="item_id">{{ id }}</td>
          <td :data-th="$gettext('Název')" class="first_data">{{ getBroadcast(id).text }}</td>
          <td :data-th="$gettext('Kanál')">{{ getBroadcast(id).channel_name }}</td>
          <td :data-th="$gettext('Datum a čas')">{{ getBroadcast(id).datetime }}</td>
          <td class="no_padding edit" v-if="!disabled">
            <div class="edit_inner">
              <a class="btn btn_action btn_delete" :title="$gettext('Smazat')" @click.stop="removeBroadcast(id)" v-translate>Smazat</a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "BroadcastSortableTable",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    broadcastNames: Object,
    disabled: Boolean,
    name: {
      type: String,
      default: "broadcasts",
    },
  },
  data() {
    return {
      sortingEnabled: false,
    };
  },
  mounted() {
    this.$nextTick(this._initSorting);
  },
  updated() {
    const exists = $('.sortable_' + this.name).length > 0;
    if (exists && !this.sortingEnabled) {
      this._initSorting();
    } else if (!exists && this.sortingEnabled) {
      this.sortingEnabled = false;
    }
  },
  methods: {
    getBroadcast(id) {
      return this.broadcastNames && this.broadcastNames[id] || {};
    },
    removeBroadcast(id) {
      if (this.disabled) {
        return;
      }
      this.$emit('input', this.value.filter(item => item !== id));
    },
    _initSorting() {
      if (!this.disabled && $('.sortable_' + this.name).length > 0) {
        $('.sortable_' + this.name).sortable({
          stop: this._sorted,
        });
        this.sortingEnabled = true;
      }
    },
    _sorted() {
      const order = [];
      $('.sorted_' + this.name).each((el, x) => {
        order.push($(x).attr('rowvalue'));
      });
      const sorted = order
          .map(idStr => this.value.find(id => String(id) === idStr))
          .filter(id => id !== undefined);
      this.$emit('input', sorted);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/BroadcastSortableTable.vue